import {
  PASSWORD_LENGTH_REGEX,
  PASSWORD_LETTERS_REGEX,
  PASSWORD_NUMBERS_REGEX,
  PASSWORD_SPECIAL_CHARACTERS_REGEX,
} from '@utils/regex';

/**
 * Validates the given password's length.
 * @param value type of @string
 */
export const lengthValidator = (value: string) => {
  if (PASSWORD_LENGTH_REGEX.test(value)) {
    return true;
  }
  return false;
};

/**
 * Checks whether the password contains any letters.
 * @param value type of @string
 */
export const lettersValidator = (value: string) => {
  if (PASSWORD_LETTERS_REGEX.test(value)) {
    return true;
  }
  return false;
};

/**
 * Checks whether the password contains any numbers.
 * @param value type of @string
 */
export const numbersValidator = (value: string) => {
  if (PASSWORD_NUMBERS_REGEX.test(value)) {
    return true;
  }
  return false;
};

/**
 * Checks whether the password contains any special characters.
 * @param value type of @string
 */
export const specialCharactersValidator = (value: string) => {
  if (PASSWORD_SPECIAL_CHARACTERS_REGEX.test(value)) {
    return true;
  }
  return false;
};
